import { UniversalSearchRequestModelInterface } from './universal-search-request.model.interface';

export class RequestBodyCompany implements UniversalSearchRequestModelInterface {
    company_domains?: string[] = [];
    company_ids?: any = [];
    company_location_states;
    company_location_metro?: string[] = [];
    company_naics_codes ?:any= [];
    company_max_revenue?: number;
    company_max_size?: number;
    company_min_revenue?: number;
    company_min_size?: number;
    company_score_max?: number;
    company_score_min?: number;
    company_technographic_categories: string[];
    company_technographic_products: any[];
    company_technographic_vendors: any[];
    page?: number = 1;
    page_size?: number =100;
    sort_by ?: string = 'company_score';
    sort_direction?: string = 'asc';
    lists?: number[] = [];
    suppression_lists?: number[] = [];
    technographics?: number = 0;
    verified?: number;
    is_international?: number = null;
    location_country_codes ?= [];
    accuracy_tier_company: string = 'MV';
    department_size: any[] = [];
    include_primary_industry_only: boolean = false;
    company_location_hq;
    icpintel_job_uuid: string = null;
}

export class RequestBodyContact implements UniversalSearchRequestModelInterface {
    company_ids?: any = [];
    company_location_metro: string[];
    company_domains?: [] = [];
    company_names?: string[] = [];
    keyword: string;
    lists?: number[] = [];
    page?: number = 1;
    page_size?: number =100;
    required_fields_all?: string = '';
    suppression_lists?: number[] = [];
    contact_lists?: number[] = [];
    tiers?: string = 'human';
    sort_by?: string = '';
    company_score_max?: number;
    company_score_min?: number;
    company_naics_codes ?:any= [];
    sort_direction?: string = 'asc';
    is_international?: number = null;
    location_country_codes?: string[] = [];
    location_types: string[] = [];
    matchOnJobHistory: boolean = true;
    accuracy_tier_contact: string = 'EV';
    icpintel_job_uuid: string = null;
}

export class RequestBodyVisitorInsight implements UniversalSearchRequestModelInterface{
    page ?= 1;
    sortBy?: string = 'default';
    sortDirection?: string = 'asc';
    dateFrom?;
    dateTo?;
    dateDelta?;
    uuId?: string;
    lists: [];
    suppression_lists: [];
    company_naics_codes: '';
    company_location_zipcodes: [];
    company_min_size: '';
    company_max_size: '';
    company_location_zipcodes_distance: 0;
    technographics: 0;
    rankings: {
        fast100: false;
        fast500: false;
        federalcontractors: false;
        forbesglobal2000: false;
        fortune500: false;
        fortune1000: false;
        fundingRoundA: false;
        fundingRoundB: false;
        fundingRoundC: false;
        fundingRoundD: false;
        fundingRoundSeed: false;
        inc5000: false;
        linkedinTopStartups2021: false;
        saas1000: false
    };
    company_technographic_categories: [];
    company_technographic_sub_categories: [];
    is_international: null;
    location_country_codes: ['US'];
    company_location_hq: true;
    company_location_branch: true;
    contact_revenue_max_identifier: 'M';
    contact_revenue_min_identifier: 'M'
}
